export const corner = ['473 473.1', `
<polygon class="st0" points="0,475.7 0,0 475.7,0 "/>
`]